import { render, staticRenderFns } from "./GroundStationStatusBadge.vue?vue&type=template&id=62ebaf20"
import script from "./GroundStationStatusBadge.vue?vue&type=script&lang=js"
export * from "./GroundStationStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports